import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {SharedModule} from '../../shared/shared.module';
import {IndustryContentCarouselComponent} from './industry-content-carousel.component';
import {IndustryContentTileComponent} from '../industry-content-tile/industry-content-tile.component';
import {GenericTileModule} from '../generic-tile/generic-tile.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        GenericTileModule
    ],
    declarations: [
        IndustryContentTileComponent,
        IndustryContentCarouselComponent
    ],
    exports: [IndustryContentCarouselComponent]
})
export class IndustryContentCarouselModule { }



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-carousel/industry-content-carousel.module.ts